/* eslint-disable i18next/no-literal-string -- Document metadata is static deployment configuration, not runtime UI copy. */
import { settings } from '@rhim/design';
import { useCookiebot } from '@rhim/react/hooks/useCookiebot';
import { type ReactNode } from 'react';
import { Links, Meta, Scripts, ScrollRestoration } from 'react-router';

import { InspectProductRuntime } from './product-runtime';

const { GlobalStyle } = settings.globals;
const COOKIEBOT_CBID = 'bb03b04f-2940-427a-94e1-06fdde42049a';

export { StaticPageLoadingScreen as HydrateFallback } from '@rhim/react/components/PageLoadingScreen';

interface LayoutProps {
  readonly children: ReactNode;
}

export function Layout({ children }: Readonly<LayoutProps>) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <title>HMD | Heat Management Desk</title>
        <base href={import.meta.env.BASE_URL} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="apple-touch-icon" href="apple-touch-icon.png" sizes="180x180" />
        <link rel="shortcut icon" type="image/x-icon" href="favicon.ico" />
        <link rel="icon" type="image/svg+xml" href="assets/fav-icons/favicon.svg" />
        <link rel="icon" type="image/png" href="assets/fav-icons/favicon-96x96.png" sizes="96x96" />
        <link rel="manifest" href="site.webmanifest" />
        <link type="text/css" rel="stylesheet" href="assets/Fonts/v2/NortW05.css" />
        <link type="text/css" rel="stylesheet" href="assets/cookiebot/styles.css" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  useCookiebot(COOKIEBOT_CBID);

  return (
    <>
      <GlobalStyle />
      <InspectProductRuntime />
    </>
  );
}
